__turbopack_context__.v({
  "gridItemContainer": "styles-module-scss-module__JJbeLG__gridItemContainer",
  "hasLink": "styles-module-scss-module__JJbeLG__hasLink",
  "imageContainer": "styles-module-scss-module__JJbeLG__imageContainer",
  "labelContainer": "styles-module-scss-module__JJbeLG__labelContainer",
});
